import "../style/PrestaTarifs.css";

function PrestaTarifs({ tab1, tab2, changeTab }) {
  return (
    <>
      <div className="front-slide">
        <span className="front-text">PRESTATIONS ET TARIFS</span>
      </div>
      <article className="presta-tarifs">
        <div className="card">
          <div className="selection">
            <button className={`${tab1 === "man" && "active"}`} onClick={() => changeTab("man")}>
              Homme
            </button>
            <span className="separation">|</span>
            <button className={`${tab1 === "woman" && "active"}`} onClick={() => changeTab("woman")}>Femme</button>
          </div>
          <table className="content">
            <thead>
              <tr>
                <th>Prestation</th>
                <th>Prix</th>
              </tr>
            </thead>
            <tbody>
              {(tab1 === "man" && (
                <>
                  <tr>
                    <td>Coupe</td>
                    <td className="price">35 €</td>
                  </tr>
                  <tr>
                    <td>Coupe partielle</td>
                    <td className="price">28 €</td>
                  </tr>
                  <tr>
                    <td>Coupe -25 ans</td>
                    <td className="price">30 €</td>
                  </tr>
                </>
              )) ||
                (tab1 === "woman" && (
                  <>
                    <tr>
                      <td>Coupe courte + séchage (1h)</td>
                      <td className="price">58 €</td>
                    </tr>
                    <tr>
                      <td>Coupe courte + brushing (1h)</td>
                      <td className="price">63 €</td>
                    </tr>
                    <tr>
                      <td>Coupe longue + brushing (1h)</td>
                      <td className="price">68 €</td>
                    </tr>
                    <tr>
                      <td>Bar à pointes (30 min)</td>
                      <td className="price">40 €</td>
                    </tr>
                    <tr>
                      <td>Coupe -25 ans</td>
                      <td className="price">50 €</td>
                    </tr>
                  </>
                ))}
            </tbody>
          </table>
        </div>
        <div className="card">
          <div className="selection">
            <button className={`${tab2 === "brushing" && "active"}`} onClick={() => changeTab("brushing")}>
              Brushing
            </button>
            <span className="separation">|</span>
            <button className={`${tab2 === "color" && "active"}`} onClick={() => changeTab("color")}>Couleur</button>
            <span className="separation">|</span>
            <button className={`${tab2 === "balayage" && "active"}`} onClick={() => changeTab("balayage")}>Balayage</button>
            <span className="separation">|</span>
            <button className={`${tab2 === "care" && "active"}`} onClick={() => changeTab("care")}>Soin</button>
          </div>
          <table className="content">
            <thead>
              <tr>
                <th>Prestation</th>
                <th>Prix</th>
              </tr>
            </thead>
            <tbody>
              {(tab2 === "brushing" && (
                <>
                  <tr>
                    <td>Shampooing + brushing court</td>
                    <td className="price">35 €</td>
                  </tr>
                  <tr>
                    <td>Shampooing + brushing long</td>
                    <td className="price">40 €</td>
                  </tr>
                </>
              )) ||
                (tab2 === "color" && (
                  <>
                    <tr>
                      <td>Couleur</td>
                      <td className="price">À partir de 58 €</td>
                    </tr>
                    <tr>
                      <td>Gloss</td>
                      <td className="price">30 €</td>
                    </tr>
                  </>
                )) ||
                (tab2 === "balayage" && (
                  <>
                    <tr>
                      <td>Flash</td>
                      <td className="price">À partir de 65 €</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Court</td>
                      <td className="price">À partir de 85 €</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Long</td>
                      <td className="price">À partir de 95 €</td>
                      <td></td>
                    </tr>
                  </>
                )) ||
                (tab2 === "care" && (
                  <>
                    <tr>
                      <td>Conditionner</td>
                      <td className="price">7 €</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Masque</td>
                      <td className="price">12 €</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Soin profond</td>
                      <td className="price">À partir de 20 €</td>
                      <td></td>
                    </tr>
                  </>
                ))}
            </tbody>
          </table>
        </div>
      </article>
    </>
  );
}

export default PrestaTarifs;
